import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'decimalFormatter',
    standalone: true,
})
export class DecimalFormatterPipe implements PipeTransform {
    
    constructor(private decimalPipe: DecimalPipe) {}
    
    transform(value: any, decimalPlaces: string = '1.2-2'): any {
        if (typeof value !== 'number' || isNaN(value)) {
            return value;
        }

        // Normal, pero por la traducción a "es-Es" en app.config.ts
        // return this.decimalPipe.transform(value, decimalPlaces);

        // Formatea el número y reemplaza comas por puntos
        const formattedValue = this.decimalPipe.transform(value, decimalPlaces);
        return formattedValue ? formattedValue.replace(/,/g, '.') : formattedValue;
    }
}